var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c("el-header", { staticClass: "header" }, [_c("HeaderComponent")], 1),
      _vm._v(" "),
      _c(
        "el-container",
        [
          _c("SideBarComponent"),
          _vm._v(" "),
          _c(
            "el-main",
            { staticClass: "main ai_main" },
            [
              _vm.global.type == "client"
                ? _c("SubTitleComponent", { attrs: { title: _vm.title } })
                : _vm._e(),
              _vm._v(" "),
              _c("div", { staticClass: "box" }, [
                _c("div", { staticClass: "tool" }, [
                  _c("h4", [_vm._v("选择客户")]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "search" },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "请选择客户",
                            loading: _vm.customerLoading,
                            filterable: ""
                          },
                          on: { change: _vm.customerChange },
                          model: {
                            value: _vm.customerValue,
                            callback: function($$v) {
                              _vm.customerValue = $$v
                            },
                            expression: "customerValue"
                          }
                        },
                        _vm._l(_vm.customerData, function(item) {
                          return _c("el-option", {
                            key: item.client_id,
                            attrs: {
                              label: item.number + " " + item.client_name,
                              value: item.client_id
                            }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("div", { staticClass: "page_header" }, [
                    _c("i", { staticClass: "el-icon-film header_icon" }),
                    _vm._v(" "),
                    _c("h3", [_vm._v("拼接长视频")])
                  ])
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("div", { staticClass: "editor_header" }, [
                    _c("h5", [
                      _vm._v(
                        "素材编辑区（" +
                          _vm._s(_vm.selectedItems.length) +
                          " 个素材）"
                      )
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "editor_actions" },
                      [
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "small",
                              plain: ""
                            },
                            on: { click: _vm.openLibrary }
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(" 从生成库选择\n              ")
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "el-button",
                          {
                            attrs: {
                              type: "success",
                              size: "small",
                              plain: ""
                            },
                            on: {
                              click: function($event) {
                                _vm.uploadOpen = true
                              }
                            }
                          },
                          [
                            _c("i", { staticClass: "el-icon-plus" }),
                            _vm._v(" 上传新素材\n              ")
                          ]
                        )
                      ],
                      1
                    )
                  ]),
                  _vm._v(" "),
                  _vm.selectedItems.length === 0
                    ? _c("div", { staticClass: "empty_editor" }, [
                        _c("i", { staticClass: "el-icon-film empty_icon" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("还没有添加素材")]),
                        _vm._v(" "),
                        _c("p", { staticClass: "empty_hint" }, [
                          _vm._v("请点击右上角按钮添加素材")
                        ])
                      ])
                    : _c(
                        "div",
                        { ref: "materialList", staticClass: "material_list" },
                        _vm._l(_vm.selectedItems, function(item, index) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              class: [
                                "material_item",
                                { dragging: _vm.dragIndex === index }
                              ],
                              attrs: { "data-index": index, draggable: "true" },
                              on: {
                                dragstart: function($event) {
                                  return _vm.handleDragStart($event, index)
                                },
                                dragover: function($event) {
                                  $event.preventDefault()
                                  return _vm.handleDragOver($event, index)
                                },
                                drop: function($event) {
                                  return _vm.handleDrop($event, index)
                                },
                                dragend: _vm.handleDragEnd,
                                touchstart: function($event) {
                                  return _vm.handleTouchStart($event, index)
                                },
                                touchmove: function($event) {
                                  return _vm.handleTouchMove($event, index)
                                },
                                touchend: _vm.handleTouchEnd
                              }
                            },
                            [
                              _c("div", { staticClass: "drag_handle" }, [
                                _c("i", { staticClass: "el-icon-rank" })
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "material_thumbnail",
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePreviewMaterial(item)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: item.thumbnail, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  item.type === "video"
                                    ? _c(
                                        "div",
                                        { staticClass: "video_overlay" },
                                        [
                                          _c("i", {
                                            staticClass: "el-icon-video-play"
                                          })
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "material_info" }, [
                                _c("p", { staticClass: "material_name" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "material_type" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.type === "video"
                                        ? "视频 · " + item.duration + "s"
                                        : "图片"
                                    )
                                  )
                                ])
                              ]),
                              _vm._v(" "),
                              _c(
                                "el-button",
                                {
                                  staticClass: "delete_btn",
                                  attrs: { type: "text" },
                                  on: {
                                    click: function($event) {
                                      return _vm.handleRemove(item.id)
                                    }
                                  }
                                },
                                [
                                  _c("i", {
                                    staticClass: "el-icon-delete",
                                    staticStyle: { color: "#f56c6c" }
                                  })
                                ]
                              )
                            ],
                            1
                          )
                        }),
                        0
                      )
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "part" }, [
                  _c("h5", [_vm._v("配乐设置")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "music_card" }, [
                    _c(
                      "div",
                      { staticClass: "music_header" },
                      [
                        _c("div", { staticClass: "music_info" }, [
                          _c("i", {
                            staticClass: "el-icon-headset music_icon"
                          }),
                          _vm._v(" "),
                          _c("div", [
                            _c("p", { staticClass: "music_title" }, [
                              _vm._v("是否增加配乐")
                            ]),
                            _vm._v(" "),
                            _c("p", { staticClass: "music_desc" }, [
                              _vm._v("模型随机生成配乐")
                            ])
                          ])
                        ]),
                        _vm._v(" "),
                        _c("el-switch", {
                          attrs: { "active-color": "#50b85c" },
                          model: {
                            value: _vm.addMusic,
                            callback: function($$v) {
                              _vm.addMusic = $$v
                            },
                            expression: "addMusic"
                          }
                        })
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _vm.addMusic
                      ? _c(
                          "div",
                          { staticClass: "music_styles" },
                          [
                            _c("h6", [_vm._v("配乐风格")]),
                            _vm._v(" "),
                            _c(
                              "el-radio-group",
                              {
                                staticClass: "music_style_group",
                                model: {
                                  value: _vm.musicStyle,
                                  callback: function($$v) {
                                    _vm.musicStyle = $$v
                                  },
                                  expression: "musicStyle"
                                }
                              },
                              [
                                _c("div", { staticClass: "style_grid" }, [
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "style_option",
                                        {
                                          selected:
                                            _vm.musicStyle === "relaxing"
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          _vm.musicStyle = "relaxing"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "relaxing" } },
                                        [_vm._v("轻松舒缓")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "style_option",
                                        {
                                          selected:
                                            _vm.musicStyle === "energetic"
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          _vm.musicStyle = "energetic"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "energetic" } },
                                        [_vm._v("活力动感")]
                                      )
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    {
                                      class: [
                                        "style_option",
                                        {
                                          selected: _vm.musicStyle === "elegant"
                                        }
                                      ],
                                      on: {
                                        click: function($event) {
                                          _vm.musicStyle = "elegant"
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "el-radio",
                                        { attrs: { label: "elegant" } },
                                        [_vm._v("优雅古典")]
                                      )
                                    ],
                                    1
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    class: [
                                      "style_option",
                                      { selected: _vm.musicStyle === "custom" }
                                    ],
                                    on: {
                                      click: function($event) {
                                        _vm.musicStyle = "custom"
                                      }
                                    }
                                  },
                                  [
                                    _c(
                                      "el-radio",
                                      { attrs: { label: "custom" } },
                                      [_vm._v("自定义风格")]
                                    )
                                  ],
                                  1
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _vm.musicStyle === "custom"
                              ? _c(
                                  "div",
                                  { staticClass: "custom_music_input" },
                                  [
                                    _c("h6", [_vm._v("自定义配乐描述")]),
                                    _vm._v(" "),
                                    _c("el-input", {
                                      attrs: {
                                        placeholder:
                                          "例如：科技感未来主义、轻快的爵士乐...",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.customMusicStyle,
                                        callback: function($$v) {
                                          _vm.customMusicStyle = $$v
                                        },
                                        expression: "customMusicStyle"
                                      }
                                    })
                                  ],
                                  1
                                )
                              : _vm._e()
                          ],
                          1
                        )
                      : _vm._e()
                  ])
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "btn_save" },
                  [
                    _c(
                      "el-button",
                      {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "success",
                          loading: _vm.isGenerating,
                          disabled:
                            _vm.selectedItems.length === 0 || !_vm.customerValue
                        },
                        on: { click: _vm.handleGenerate }
                      },
                      [
                        _c("i", { staticClass: "el-icon-film" }),
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              _vm.isGenerating ? "生成中..." : "一键生成视频"
                            ) +
                            "\n          "
                        )
                      ]
                    ),
                    _vm._v(" "),
                    _c("div", { staticClass: "prompt" }, [
                      _vm._v(
                        "（本月剩余使用额度 " +
                          _vm._s(_vm.global.money) +
                          "元）"
                      )
                    ])
                  ],
                  1
                ),
                _vm._v(" "),
                _vm.generatedVideos.length > 0
                  ? _c("div", { staticClass: "part" }, [
                      _c("h5", [_vm._v("生成记录")]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "video_result_grid" },
                        _vm._l(_vm.generatedVideos, function(video, index) {
                          return _c(
                            "div",
                            { key: video.id, staticClass: "video_result_item" },
                            [
                              _c(
                                "div",
                                {
                                  staticClass: "video_thumbnail",
                                  on: {
                                    click: function($event) {
                                      return _vm.handlePlayVideo(video)
                                    }
                                  }
                                },
                                [
                                  _c("img", {
                                    attrs: { src: video.thumbnail, alt: "" }
                                  }),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "video_play_overlay" },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-video-play"
                                      })
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "span",
                                    { staticClass: "video_duration" },
                                    [_vm._v(_vm._s(video.duration) + "s")]
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "video_info" }, [
                                _c("p", { staticClass: "video_title" }, [
                                  _vm._v(
                                    "拼接视频 " +
                                      _vm._s(index + 1) +
                                      " · " +
                                      _vm._s(video.itemCount) +
                                      " 个素材"
                                  )
                                ]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticClass: "video_actions" },
                                  [
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleCollect(video)
                                          }
                                        }
                                      },
                                      [_vm._v("收藏")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "el-button",
                                      {
                                        attrs: {
                                          size: "mini",
                                          type: "success",
                                          plain: ""
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.handleDownload(video)
                                          }
                                        }
                                      },
                                      [_vm._v("下载")]
                                    )
                                  ],
                                  1
                                )
                              ])
                            ]
                          )
                        }),
                        0
                      )
                    ])
                  : _vm._e()
              ]),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "生成库",
                    visible: _vm.libraryOpen,
                    width: "70%",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.libraryOpen = $event
                    }
                  }
                },
                [
                  _c("p", { staticClass: "dialog_hint" }, [
                    _vm._v("从过往生成的素材中选择")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "library_filter" },
                    [
                      _c("span", { staticClass: "filter_label" }, [
                        _vm._v("筛选类型")
                      ]),
                      _vm._v(" "),
                      _c(
                        "el-select",
                        {
                          staticStyle: { width: "150px" },
                          attrs: { placeholder: "请选择" },
                          model: {
                            value: _vm.filterType,
                            callback: function($$v) {
                              _vm.filterType = $$v
                            },
                            expression: "filterType"
                          }
                        },
                        [
                          _c("el-option", {
                            attrs: { label: "全部", value: "all" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "仅图片", value: "image" }
                          }),
                          _vm._v(" "),
                          _c("el-option", {
                            attrs: { label: "仅视频", value: "video" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.libraryLoading
                    ? _c("div", { staticClass: "library_loading" }, [
                        _c("i", { staticClass: "el-icon-loading" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("加载中...")])
                      ])
                    : _vm.filteredLibrary.length === 0
                    ? _c("div", { staticClass: "library_empty" }, [
                        _c("i", { staticClass: "el-icon-picture-outline" }),
                        _vm._v(" "),
                        _c("p", [_vm._v("暂无素材")])
                      ])
                    : _c(
                        "div",
                        { staticClass: "library_grid" },
                        _vm._l(_vm.filteredLibrary, function(item) {
                          return _c(
                            "div",
                            {
                              key: item.id,
                              class: [
                                "library_item",
                                { selected: _vm.isItemSelected(item.id) }
                              ],
                              on: {
                                click: function($event) {
                                  return _vm.handleAddFromLibrary(item)
                                }
                              }
                            },
                            [
                              _c("div", { staticClass: "library_thumbnail" }, [
                                _c("img", {
                                  attrs: { src: item.thumbnail, alt: "" }
                                }),
                                _vm._v(" "),
                                item.type === "video"
                                  ? _c("div", { staticClass: "video_badge" }, [
                                      _c("i", {
                                        staticClass: "el-icon-video-play"
                                      }),
                                      _vm._v(
                                        " " +
                                          _vm._s(item.duration) +
                                          "s\n              "
                                      )
                                    ])
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isItemSelected(item.id)
                                  ? _c(
                                      "div",
                                      { staticClass: "selected_overlay" },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "selected_badge" },
                                          [_vm._v("已添加")]
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "library_item_info" }, [
                                _c("p", { staticClass: "name" }, [
                                  _vm._v(_vm._s(item.name))
                                ]),
                                _vm._v(" "),
                                _c("p", { staticClass: "type" }, [
                                  _vm._v(
                                    _vm._s(
                                      item.type === "video" ? "视频" : "图片"
                                    )
                                  )
                                ])
                              ])
                            ]
                          )
                        }),
                        0
                      ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      staticClass: "dialog_footer",
                      attrs: { slot: "footer" },
                      slot: "footer"
                    },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { type: "success" },
                          on: {
                            click: function($event) {
                              _vm.libraryOpen = false
                            }
                          }
                        },
                        [_vm._v("完成")]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "上传新素材",
                    visible: _vm.uploadOpen,
                    width: "600px",
                    "close-on-click-modal": false
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.uploadOpen = $event
                    }
                  }
                },
                [
                  _c("p", { staticClass: "dialog_hint" }, [
                    _vm._v("支持上传图片（JPG、PNG）或视频文件")
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "upload_dialog_content" },
                    [
                      _c(
                        "el-upload",
                        {
                          staticClass: "upload_dragger",
                          attrs: {
                            drag: "",
                            action: "",
                            "auto-upload": false,
                            "show-file-list": false,
                            "on-change": _vm.handleUpload,
                            accept: "image/*,video/*"
                          }
                        },
                        [
                          _c("i", { staticClass: "el-icon-upload" }),
                          _vm._v(" "),
                          _c("div", { staticClass: "el-upload__text" }, [
                            _vm._v("将文件拖到此处，或"),
                            _c("em", [_vm._v("点击上传")])
                          ])
                        ]
                      )
                    ],
                    1
                  )
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "视频播放",
                    visible: _vm.videoPlayerOpen,
                    width: "auto",
                    "close-on-click-modal": true,
                    "custom-class": "video-preview-dialog",
                    "modal-append-to-body": true,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.videoPlayerOpen = $event
                    },
                    close: function($event) {
                      _vm.currentPlayingVideo = null
                    }
                  }
                },
                [
                  _vm.currentPlayingVideo
                    ? _c("div", { staticClass: "video_player_container" }, [
                        _c(
                          "video",
                          {
                            staticClass: "video_player",
                            attrs: {
                              src: _vm.currentPlayingVideo.url,
                              controls: "",
                              autoplay: "",
                              controlsList: "nodownload"
                            }
                          },
                          [
                            _vm._v(
                              "\n            您的浏览器不支持视频播放\n          "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("div", { staticClass: "video_player_info" }, [
                          _c("p", { staticClass: "player_video_title" }, [
                            _vm._v(
                              "拼接视频 · " +
                                _vm._s(_vm.currentPlayingVideo.itemCount) +
                                " 个素材"
                            )
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "player_video_duration" }, [
                            _vm._v(
                              "时长: " +
                                _vm._s(_vm.currentPlayingVideo.duration) +
                                "s"
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              ),
              _vm._v(" "),
              _c(
                "el-dialog",
                {
                  attrs: {
                    title: "素材预览",
                    visible: _vm.materialPreviewOpen,
                    width: "auto",
                    "close-on-click-modal": true,
                    "custom-class": "video-preview-dialog",
                    "modal-append-to-body": true,
                    "append-to-body": true
                  },
                  on: {
                    "update:visible": function($event) {
                      _vm.materialPreviewOpen = $event
                    },
                    close: function($event) {
                      _vm.currentPreviewMaterial = null
                    }
                  }
                },
                [
                  _vm.currentPreviewMaterial
                    ? _c("div", { staticClass: "material_preview_container" }, [
                        _vm.currentPreviewMaterial.type === "video"
                          ? _c(
                              "video",
                              {
                                staticClass: "material_preview_video",
                                attrs: {
                                  src: _vm.currentPreviewMaterial.url,
                                  controls: "",
                                  autoplay: ""
                                }
                              },
                              [
                                _vm._v(
                                  "\n            您的浏览器不支持视频播放\n          "
                                )
                              ]
                            )
                          : _c("img", {
                              staticClass: "material_preview_image",
                              attrs: {
                                src:
                                  _vm.currentPreviewMaterial.url ||
                                  _vm.currentPreviewMaterial.thumbnail,
                                alt: ""
                              }
                            }),
                        _vm._v(" "),
                        _c("div", { staticClass: "material_preview_info" }, [
                          _c("p", { staticClass: "preview_name" }, [
                            _vm._v(_vm._s(_vm.currentPreviewMaterial.name))
                          ]),
                          _vm._v(" "),
                          _c("p", { staticClass: "preview_type" }, [
                            _vm._v(
                              _vm._s(
                                _vm.currentPreviewMaterial.type === "video"
                                  ? "视频 · " +
                                      _vm.currentPreviewMaterial.duration +
                                      "s"
                                  : "图片"
                              )
                            )
                          ])
                        ])
                      ])
                    : _vm._e()
                ]
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c669591a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c669591a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/VideoStitching/Index.vue
// module id = null
// module chunks = 